// browser detection - put this in front of other code to ignore error in old browsers
document.addEventListener('DOMContentLoaded', function() {
    var alertBox = document.getElementById("login-logout-main-browser-detection");
    if (!alertBox) return;

    if ((bowser.msie && bowser.version < 11) ||
        (bowser.chrome && bowser.version < 57) ||
        (bowser.firefox && bowser.version < 52) ||
        (bowser.safari && bowser.version < 11)) {

        alertBox.className = alertBox.className.replace(/\bhidden\b/g, "");
    }
});